import { ReactMap, ReactMapProps } from '@innovyze/inno-map';
import { useReactMapConfig } from '@innovyze/stylovyze';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useLayerConfig } from './useLayerConfig';
import { useDataServices } from './useDataServices';

const StyledMap = styled.div`
	width: 100%;
	height: 50%;
`;

interface Props {
	configId: string;
	focusedAssets: ReactMapProps['focusedAssets'];
}

export const RiskDetailsMap = ({ configId, focusedAssets }: Props) => {
	const reactMapConfig = useReactMapConfig();

	const layerConfig = useLayerConfig(configId);

	const dataService = useDataServices(configId);

	const featureVariations = useSelector(
		(state: {
			features?: {
				variations?: Record<
					string,
					| boolean
					| string
					| number
					| Record<string, unknown>
					| undefined
				>;
			};
		}) => state.features?.variations,
	);

	const featureFlagBridge = useMemo(
		() => ({
			getVariation: (key: string) => featureVariations?.[key] ?? false,
		}),
		[featureVariations],
	);

	return (
		<StyledMap>
			<ReactMap
				config={reactMapConfig}
				layerConfig={layerConfig}
				dataServices={dataService}
				focusedAssets={focusedAssets}
				zoomToFocusedAssets
				featureFlagBridge={featureFlagBridge}
			/>
		</StyledMap>
	);
};
